function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 752 400"
}, props), /*#__PURE__*/React.createElement("title", null, "Google Pay"), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M552 0H200C90 0 0 90 0 200s90 200 200 200h352c110 0 200-90 200-200S662 0 552 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3c4043",
  d: "M552 16a181 181 0 01130 54 184 184 0 0139 201 185 185 0 01-169 113H200a181 181 0 01-130-54 184 184 0 01-39-201A185 185 0 01200 16h352m0-16H200C90 0 0 90 0 200s90 200 200 200h352c110 0 200-90 200-200S662 0 552 0zM359 214v61h-20V125h51c13 0 24 5 33 13 9 9 14 19 14 32 0 12-5 23-14 31-9 9-20 13-33 13h-31zm0-70v52h32c7 0 14-3 19-8a25 25 0 000-36c-5-6-12-8-19-8h-32zm128 25c14 0 26 4 34 12 8 7 12 18 12 31v63h-18v-14h-1c-8 11-18 17-32 17-11 0-20-3-28-10s-11-15-11-25c0-11 4-19 12-25s18-10 32-10c11 0 20 3 28 7v-5c0-6-3-12-8-17-5-4-12-7-19-7-10 0-19 5-25 14l-17-11c9-13 23-20 41-20zm-25 74c0 5 2 10 7 13 4 3 9 5 15 5 8 0 15-3 21-9 7-6 10-13 10-21-6-5-15-7-25-7-8 0-15 2-20 5-5 4-8 9-8 14zm176-71l-64 148h-20l24-52-43-96h21l31 74 30-74z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M282 202l-1-18h-81v33h47c-2 11-8 20-18 27v21h28c16-15 25-37 25-63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M229 244c-7 5-17 8-29 8-22 0-41-15-48-36h-28v23c14 27 43 47 76 47 23 0 43-8 57-21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fabb05",
  d: "M149 200c0-6 1-11 3-16v-22h-28a85 85 0 000 77l28-23c-2-5-3-10-3-16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e94235",
  d: "M200 148c13 0 24 5 33 13l24-24a86 86 0 00-134 25l29 22c7-21 26-36 48-36z"
})));